import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ScheduleTable_ScheduleFragment } from '../__generated__/ScheduleTable.graphql';

export function DescriptionCell({
  value,
}: PropsWithChildren<CellProps<ScheduleTable_ScheduleFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
      {value}
    </Box>
  );
}

DescriptionCell.graphql = {
  fragments: {
    DescriptionCell_schedule: gql`
      fragment DescriptionCell_schedule on Schedule {
        id
        description
      }
    `,
  },
};
